import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

const Impressum = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white py-24 px-6 md:px-12 lg:px-24 font-light">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-12 transition-colors uppercase tracking-widest text-sm">
          <SafeIcon icon={FiArrowLeft} /> Zurück zur Startseite
        </Link>
        
        <h1 className="text-4xl md:text-6xl font-black mb-12 tracking-tight">Impressum</h1>
        
        <div className="space-y-8 text-gray-300 leading-relaxed max-w-2xl">
          <section>
            <h2 className="text-xl font-medium text-white mb-4">Angaben gemäß § 5 TMG</h2>
            <p>
              Dervis Baygül<br />
              Mathildenstr 37<br />
              63065 Offenbach
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-white mb-4">Kontakt</h2>
            <p>
              E-Mail: info@bayguel.de<br />
              Website: https://bayguel.de
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-white mb-4">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-medium text-white mb-4">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;